import { render, staticRenderFns } from "./GenericListing.vue?vue&type=template&id=0e52a972&scoped=true"
import script from "./GenericListing.vue?vue&type=script&lang=ts"
export * from "./GenericListing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e52a972",
  null
  
)

export default component.exports